import { render, staticRenderFns } from "./ManageColumnName.vue?vue&type=template&id=75e48394&scoped=true&"
import script from "./ManageColumnName.vue?vue&type=script&lang=js&"
export * from "./ManageColumnName.vue?vue&type=script&lang=js&"
import style0 from "./ManageColumnName.vue?vue&type=style&index=0&id=75e48394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e48394",
  null
  
)

export default component.exports